import Tabs from './tabs';

export default class TabsDesktop extends Tabs {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/tabs/tabs.desktop.js